<template>
    <div class="introductionBox">
        <businessBanner tabIndex="1"></businessBanner>
        <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="font20 fontw">全咨业务</p>
            <p class="mt36 jies">为全面落实《国务院办公厅关于促进建筑业持续健康发展的意见》（国办发〔2017〕19号）及《关于推进全过程工程咨询服务发展的指导意见》（发改投资规〔2019〕515号）等政策文件，瑞和安惠总结项目代建经验，将招标采购、投资咨询、造价咨询、管理咨询、BIM应用及数智化应用进行有机结合，形成了独具特色的全过程咨询服务模式，服务内容涵盖投资决策综合性咨询与工程建设全过程咨询。</p>
            <p class="jies">凭借前瞻性的发展理念、多元化的人才储备以及完善的服务链条，经过多年的精心培育与实践磨炼，瑞和安惠组建完成了多个全咨服务团队，服务网点遍布河北省11个地市及雄安新区，并在全国十余个省份设立了分支机构，在保障服务高效、品质卓越的同时，持续精进专业技术，拓宽服务范围，深化数智化应用，锻造核心竞争力，以全周期专业陪伴助力项目增值！</p>
        </div>
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main'">
                <p class="contT">服务理念</p>
                <p class="jies">瑞和安惠坚持以"推动管理进步，赋能智慧工程"为使命，以"领先的全过程工程咨询服务提供商"为愿景，始终秉承"成就客户、务实守信、合作共进、创新发展"的价值观和"诚信至高处，服务无限时"的服务理念。在保障服务高效、品质卓越的同时，持续精进专业技术，深化数智化应用，锻造咨询服务核心竞争力，以全周期专业陪伴助力项目增值！</p>
            </div>
        </div>
        <div :class="isMobile?'mobileShow':'mainShow'">
            <p class="contT mt36">资质资信</p>
            <p class="jies">瑞和安惠凭借二十多年的积累与沉淀，获取了多项国家核发的甲级资质/资信，涵盖招标采购、投资咨询、造价咨询、管理咨询等工程咨询多个行业，凭借优质的资质资信资源，构建了投资决策综合性咨询及工程建设全过程咨询等全过程服务链条，形成了覆盖项目全生命周期的专业化、一体化服务体系。</p>
        </div>
        <div :class="isMobile?'mobileShows':'mainShows'">
            <div :class="isMobile?'mainM':'main'">
                <p class="contT">全咨团队</p>
                <p class="jies">经过二十多年的精心培育与实践磨炼，瑞和安惠组建了多个业务范围宽泛、专业领域全面、技术能力精深、数智化创新应用的全过程咨询服务团队，涉及招标采购、投资咨询、造价咨询、管理咨询、BIM应用以及数智化应用等多个业务板块，服务范围涵盖国民经济各主要行业。瑞和安惠坚持以重大项目实战经验和跨领域协同能力为标准，持续打造高、精、尖、深、广全咨技术团队，为客户提供专家级服务保障、精细化服务成果、高价值智力服务、专业级解决方案与全周期项目陪伴。</p>
            </div>
        </div>
        <!-- 典型业绩展示 -->
        <TypicalAchievement business-type="全过程咨询" :show-tabs="false" />
    </div>
</template>

<script>
import businessBanner from '@/components/businessBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'
export default {
    name: 'EarlierConsultation',
    components: { businessBanner, TypicalAchievement },
    data() {
        return {}
    },
    mounted() {}
}
</script>

<style scoped>
.introductionBox {
    padding-bottom: 50px;
}
.mainShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 42px;
}
.mobileShows {
    width: 100%;
    background-color: #F7F9FD;
    margin-top: 20px;
}
.main {
    width: 1200px;
    margin: 0 auto;
    padding: 48px 0;
    padding-bottom: 67px;
}
.mainM {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.jies {
    line-height: 30px;
    text-indent: 2em;
}
.contT {
    color: #247CD6;
    font-size: 28px;
    margin-bottom: 20px;
}
</style>
